import { useState } from "react";
import { useUser } from "../../../../contexts/userContext/userContext.js";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";

const useComment = (initState, allData, addComment, editComment, fileId) => {
  const [newCommentData, setNewCommentData] = useState(initState);
  const { getUserData } = useUser();
  const { getMailId } = useMail();

  const handleAddComment = (recaptchaResponse) => {
    if (newCommentData.content.trim() !== "")
      addComment({
        relevantFile: fileId || null,
        parent: newCommentData.reply,
        content: newCommentData.content,
        mailId: getMailId(),
        recaptchaResponse,
      });
    setNewCommentData(initState);
  };

  const handleSaveComment = (recaptchaResponse) => {
    const content =
      newCommentData.content.trim() !== ""
        ? newCommentData.content
        : allData[newCommentData.id].Content;
    editComment({
      id: newCommentData.id,
      content: content,
      mailId: getMailId(),
      recaptchaResponse,
    });
    setNewCommentData(initState);
  };

  const handleSubmit = async (recaptchaResponse) => {
    if (recaptchaResponse) {
      newCommentData.id
        ? handleSaveComment(recaptchaResponse)
        : handleAddComment(recaptchaResponse);
    }
  };

  return {
    newCommentData,
    setNewCommentData,
    handleAddComment,
    handleSaveComment,
    handleSubmit,
  };
};

export default useComment;
